import AutoPlayRiveComponent from './AutoPlayRiveComponent'
import { formatNumberWithoutCurrency } from '../../utils/utils'
import { GROUPED_STATIC_TEXT_ROLE } from '../ui-components/NameValueTableRow'

export const Pricing = ({ launchPriceCaption = 'Special launch price', amount = 0 }) => {
  const formattedAmount = formatNumberWithoutCurrency(amount ?? 0)

  return (
    <div className='flex flex-col justify-center items-center'>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label={`All this at just ₹${formattedAmount} per year + GST`}
        className='flex flex-col justify-center items-center'
      >
        <div aria-hidden='true' className='text-[14px] text-black'>
          All this at just
        </div>
        <div aria-hidden='true' className='flex gap-2 items-end text-black'>
          <div className='text-[32px] font-[700]'>
            ₹{formattedAmount}
            <span className='text-[22px] font-[400]'>/yr</span>
          </div>
          <div className='pb-[6px] text-[13px]'>+ GST</div>
        </div>
      </div>
      <div className='pt-2'>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label={launchPriceCaption}
          className='h-6 px-3 py-2 bg-[#FFF2DF] rounded-lg justify-center items-center gap-1 inline-flex'
        >
          <div
            aria-hidden='true'
            className='text-center text-xs font-medium bg-gradient-to-r from-[#CC5C2D] via-[#953A13] to-[#CC5C2D] text-transparent bg-clip-text  leading-tight'
          >
            {launchPriceCaption}
          </div>
        </div>
      </div>
      <div className='pt-10 w-full'>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label="A price that's less than"
          className='pb-6 text-[14px] font-[500] text-center'
        >
          <span aria-hidden='true'> A price that’s less than</span>
        </div>
        <div className='h-16 w-full'>
          <AutoPlayRiveComponent riveUrl='/marquee.riv' riveFit={'fitWidth'} isLoop={true} />
        </div>
      </div>
    </div>
  )
}
